export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const TIME_FORMAT = 'HH:mm:ss'

export const PATH = {
  LOGIN: '/',
  BROWSER: '/browser',
  ANALYSIS: '/analysis'
}

const proximalColor = getComputedStyle(document.documentElement).getPropertyValue('--text-section-proximal').trim();
const midColor = getComputedStyle(document.documentElement).getPropertyValue('--text-section-mid').trim();
const distalColor = getComputedStyle(document.documentElement).getPropertyValue('--text-section-distal').trim();

export const CPR_CHART_COLORS = {
  proximal: proximalColor,
  mid: midColor,
  distal: distalColor,
  // proxiamlNomalizedRgb: [1, 0.31, 0.51],
  // midNomalizedRgb: [0.96, 0.96, 0.96],
  // distalNomalizedRgb: [1, 0.55, 0],
} as const;
